<template>
  <div>
    <SlideShowSection />
    <DifferentialsSection />
    <ServicesSection />
    <AboutSection />
    <ArticlesSection />
    <VideosShortsSection />
    <ClientsSection />
    <ReviewsSection />
    <ContactSection />
  </div>
</template>

<script>
import AboutSection from "../components/sections/AboutSection.vue";
import DifferentialsSection from "../components/sections/DifferentialsSection.vue";
import ServicesSection from "../components/sections/ServicesSection.vue";
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import ClientsSection from "../components/sections/ClientsSection.vue";
import ReviewsSection from "../components/sections/ReviewsSection.vue";
import ContactSection from "../components/sections/ContactSection.vue";
import VideosShortsSection from "../components/sections/VideosShortsSection.vue";

export default {
  components: {
    SlideShowSection,
    DifferentialsSection,
    ServicesSection,
    AboutSection,
    ArticlesSection,
    VideosShortsSection,
    ContactSection,
    ClientsSection,
    ReviewsSection,
  },
};
</script>
